import React from 'react';
import * as Yup from 'yup';
import * as RFIcon from 'react-feather'; 
import RoleDisplay from '../base/components/RoleDisplay';
import { Avatar, Box } from '@material-ui/core';
import language from '../languages';
import {firestore} from "../firebase";
import buildQuery from "./EntityUtil"

const meta = (lang) => { 
    return {
        entityName: language[lang].User,
        entityTitle: language[lang].Users,
        emptyRow: () => {
            return {
                firstName: '',
                lastName: '',
                email: '',
                roles: [],
                isActive: true,
                language: 'en',
                note: '',
                profileImageUrl: 'https://via.placeholder.com/800'
            }
        },
        collection: 'users',
        hideTitle: true,
        addButtonText: language[lang].New_User,
        // addButtonText: () => {
        //     return <><RFIcon.Plus strokeWidth={2}/> &nbsp; Add New </>
        //     },
        fields: [
            {name: 'firstName', default: null, dataType: 'string', label: 'First Name', input: 'text'},
            {name: 'lastName', default: null, dataType: 'string', label: 'Last Name', input: 'text'},
            {name: 'email', default: null, dataType: 'string', label: 'E-mail', input: 'text'},
            {name: 'isActive', default: true, dataType: 'boolean', label: 'Activate', input: 'switch', color: 'primary'},
            // {name: 'profileImageUrl', default: null, dataType: 'string', label: 'Image', input: 'file'},
            {name: 'language', default: null, dataType: 'array', label: 'Language', input: 'select',
                getItems: ()=> {
                    return new Promise((resolve, reject)=> {
                        resolve([
                            {value: 'en', label: 'English'},
                            {value: 'hi', label: 'Hindi'},
                        ])
                    })
                }
            },
            {name: 'roles', default: null, dataType: 'array', label: 'Roles', input: 'multiselect',
                getItems: ()=> {
                    return new Promise((resolve, reject)=> {
                        resolve ([
                            {value: 'ADMIN', label: 'Admin'},
                            {value: 'CUSTOMER', label: 'Customer'},
                            {value: 'VENDOR', label: 'Vendor'},
                            {value: 'RIDER', label: 'Rider'},
                            {value: 'SUPER_RIDER', label: 'Super Rider'}
                        ])
                    })
                }
            },
        ],
        table: [
            {name: 'name', type: 'field', label: 'Name',
                render: (doc)=> {
                    return (
                        <> 
                            <Avatar component="span" alt={doc.name} src={doc.profileImageUrl} style={{display:'inline-flex'}} />
                            <span style={{position: 'relative', bottom:'12px'}}> &nbsp; {doc.name} </span> 
                        </> 
                    )}
            },
            // {name: 'firstName', type: 'field', label: 'First Name'},
            // {name: 'lastName', type: 'field', label: 'Last Name'},
            // {name: 'email', type: 'field', label: 'E-mail'},
            {name: 'role', type: 'field', label: 'Role',
                render: (doc)=> {return <RoleDisplay roles={doc.roles}/>}
            },
            // {name: 'linkedAccount', type:'field', label: 'Linked Account'},
            // {name: 'profileImageUrl', type: 'field', label: 'Image', showImg: true},
            {name: 'isActive', type: 'conditionField', label: 'Status', textForTrue: 'Active', textForFalse: 'Inactive'},
            {name: 'actions', type: 'action', label:'Actions', actions: ['delete', 'edit']}
        ],
        transform: (doc, id)=> {
            doc.role = doc.roles[0];
            doc.name = doc.firstName + ' ' + doc.lastName
            doc.linkedAccount = doc.facebook ? 'Facebook' : '';
            //TODO:
            return doc;
        },
        validationSchema: Yup.object({
            firstName: Yup.string()
                .required(language[lang].Field_Required),
            lastName: Yup.string()
                .required(language[lang].Field_Required),
            email: Yup.string()
                .email()
                .required(language[lang].Field_Required),
            roles: Yup.string()
                .required(language[lang].Field_Required),
            language: Yup.string()
                .required(language[lang].Field_Required),
        }),
        filterObject: [],
        defaultOrderBy: ['firstName', 'asc'],
        searchableColumns: ['firstName','lastName','email'],
        getQuery: (paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage) => {
            let query = {};
            query = firestore.collection('users');
            return buildQuery(query, paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage);
        },
        beforeSave: (user, doc)=> {
            if(doc.releaseDate){
                doc.releaseDate = new Date(doc.releaseDate).getTime();
            }
            return doc
        }
    }
}

export default meta;